/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
(function () {
  if (!window || !window.Shopify) return;

  const CartEvents = {
    add: 'SCE:add',
    update: 'SCE:update',
    change: 'SCE:change',
    clear: 'SCE:clear',
    mutate: 'SCE:mutate',
  };

  const ShopifyCartURLs = ['/cart/add', '/cart/update', '/cart/change', '/cart/clear', '/cart/add.js', '/cart/update.js', '/cart/change.js', '/cart/clear.js'];

  /**
   * Detect is request path is Shopify Cart
   *
   * @param {string} url event request url
   * @returns {boolean} true/false
   */
  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split('/').pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
  }

  /**
   * @param {string} url event request url
   * @returns {string} return type of event
   */
  function updateType(url) {
    if (!url) return false;
    if (url.includes('cart/add')) {
      return 'add';
    }
    if (url.includes('cart/update')) {
      return 'update';
    }
    if (url.includes('cart/change')) {
      return 'change';
    }
    if (url.includes('cart/clear')) {
      return 'clear';
    }
    return false;
  }

  /**
   * Dispatch custom cart events
   *
   * @param {string} url event request url
   * @param {object} detail details
   */
  function dispatchEvent(url, detail) {
    if (typeof detail === 'string') {
      try {
        // eslint-disable-next-line no-param-reassign
        detail = JSON.parse(detail);
      } catch {
        /* empty */
      }
    }

    window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
      case 'add':
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case 'update':
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
      case 'change':
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
      case 'clear':
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
      default:
        break;
    }
  }

  /**
   *
   */
  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    /**
     * @returns {Function} callback
     */
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener('load', function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  /**
   *
   */
  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== 'function') return;
    const originalFetch = window.fetch;
    /**
     * @returns {object} response object
     */
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);

      if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
      }
      return response;
    };
  }

  fetchOverride();
  XHROverride();
})();
// window.addEventListener('SCE:mutate', (event) => {
//   // event.detail will be Shopify Cart object
//   console.log(event);
// });

// window.addEventListener('SCE:add', (event) => {
//   // event.detail will be Shopify Cart object
//   console.log(event);
// });

// window.addEventListener('SCE:update', (event) => {
//   // event.detail will be Shopify Cart object
//   console.log(event);
// });

// window.addEventListener('SCE:change', (event) => {
//   // event.detail will be Shopify Cart object
// });

// window.addEventListener('SCE:clear', (event) => {
//   // event.detail will be Shopify Cart object
// });
